import React, { Component } from 'react';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';
import { css } from '@emotion/core';

import A from '../../../Anchor/Anchor';
import Link from '../../../Link/Link';
import Cart from '../../../Icons/Cart';
import {
  updateCartQuantity,
  removeFromCart,
  getMaxAddable,
} from '../../../../../redux/modules/cart';
import {
  primary_l50,
  primary_s5_l70_a015,
  primary_s20_l70_a025,
} from '../../../lib/colors';
import { removeFromCartEvent } from '../../../lib/gaEnhancedEcommerce';
import Price from '../../../Price/Price';
import SingleCartItem from './SingleCartItem/SingleCartItem';
import {
  ga4AddToCart,
  ga4RemoveFromCart,
  ga4ViewCart,
} from '../../../lib/ga4EnhancedEcommerce';
import {
  fkmxAddToCart,
  fkmxRemoveFromCart,
  fkmxViewCart,
} from '../../../lib/farmakomMetrics';
import {
  gtmToGa4AddToCart,
  gtmToGa4RemoveFromCart,
  gtmToGa4ViewCart,
} from '../../../lib/gtmEnhancedEcommerce';

import './CartMenu.scss';

class CartMenu extends Component {
  componentDidUpdate(oldProps) {
    if (
      this.props.showCartMenu !== oldProps.showCartMenu &&
      !!this.props.showCartMenu
    ) {
      // VIEW CART - GTM, GA4, FKMX
      if (
        [
          this.props.hasGoogleTagManager,
          this.props.hasGoogleAnalytics4Advanced,
          this.props.hasFarmakomMetrics,
        ]
      ) {
        this.viewCart();
      }
    }
  }

  viewCart = () => {
    const total = this.props.cart.reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);
    if (this.props.hasGoogleTagManager) {
      // GTM VIEW CART
      gtmToGa4ViewCart(this.props.cart, total);
    }
    if (this.props.hasGoogleAnalytics4Advanced) {
      // GA4 VIEW CART
      ga4ViewCart(this.props.cart, total);
    }
    if (this.props.hasFarmakomMetrics) {
      // FKMX VIEW CART
      fkmxViewCart(this.props.cart, total);
    }
  };

  handleClickOutside = event => {
    let { onCloseCartMenu } = this.props;

    return onCloseCartMenu(event);
  };

  decrement = product => event => {
    event.preventDefault();
    if (product.quantity > 1) {
      this.props.updateCartQuantity(product.id, product.quantity - 1);
    }
    // GTM REMOVE FROM CART
    if (this.props.hasGoogleTagManager) {
      gtmToGa4RemoveFromCart({ ...product, quantity: 1 });
    }
    // GA4 REMOVE FROM CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4RemoveFromCart({ ...product, quantity: 1 });
    }
    // FKMX REMOVE FROM CART
    if (this.props.hasFarmakomMetrics) {
      fkmxRemoveFromCart({ ...product, quantity: 1 });
    }
  };

  increment = product => event => {
    event.preventDefault();

    const maxAddable = getMaxAddable(this.props.globalState, product);
    const { minNumInCart } = product;

    if (maxAddable > 0) {
      // Posso aggiungere al carrello
      let newQuantity = product.quantity + 1;

      // Se c'è una quantità minima carrello e non l'ho raggiunta
      if (minNumInCart && product.quantity < minNumInCart) {
        // La nuova quantità è il minimo tra
        // la quantità minima carrello e il numero
        // massimo di pezzi che possono stare nel carrello
        newQuantity = Math.min(minNumInCart, maxAddable + product.quantity);
      }

      // Applico nuova quantità
      this.props.updateCartQuantity(product.id, newQuantity);

      // GTM ADD TO CART
      if (this.props.hasGoogleTagManager) {
        gtmToGa4AddToCart({ ...product, quantity: 1 });
      }
      // GA4 ADD TO CART
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4AddToCart({ ...product, quantity: 1 });
      }
      // FKMX ADD TO CART
      if (this.props.hasFarmakomMetrics) {
        fkmxAddToCart({ ...product, quantity: 1 });
      }
    }
  };

  removeFromCart = product => event => {
    event.preventDefault();
    this.props.removeFromCart(product);

    if (this.props.advancedGa) {
      removeFromCartEvent({
        id: product.code || '',
        name: product.name,
        category: product.categoryName,
        brand: product.brand,
        price: product.price,
        quantity: product.quantity,
      });
    }
    // GTM REMOVE FROM CART
    if (this.props.hasGoogleTagManager) {
      gtmToGa4RemoveFromCart(product);
    }
    // GA4 REMOVE FROM CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4RemoveFromCart(product);
    }
    // FKMX REMOVE FROM CART
    if (this.props.hasFarmakomMetrics) {
      fkmxRemoveFromCart(product);
    }
  };

  renderCartItems() {
    const { primaryColor, uiVariantButton } = this.props;

    return this.props.cart.map(product => {
      return (
        <SingleCartItem
          key={product.id}
          product={product}
          onIncrement={this.increment(product)}
          onDecrement={this.decrement(product)}
          onRemove={this.removeFromCart(product)}
          primaryColor={primaryColor}
          uiVariantButton={uiVariantButton}
        />
      );
    });
  }

  renderCartTotal() {
    return this.props.cart.reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);
  }

  renderCartItemsQuantity() {
    return this.props.cart.reduce((total, product) => {
      return total + product.quantity;
    }, 0);
  }

  renderCartMenu() {
    const { cart, onCloseAll } = this.props;

    if (cart && cart.length > 0) {
      return (
        <div className="cart-menu">
          <div className="cart-menu-items">{this.renderCartItems()}</div>
          <hr />
          <div className="total">
            <span className="text">Totale:</span>
            <span className="amount">
              <Price amount={this.renderCartTotal()} />
            </span>
          </div>
          <hr />
          <div className="cart-checkout">
            <Link
              to="/carrello"
              className="btn btn-primary"
              onClick={onCloseAll}
            >
              Vai al carrello
            </Link>
          </div>
        </div>
      );
    }

    // Else, no products in cart
    return (
      <div className="cart-menu">
        <div className="total">Non ci sono articoli nel carrello</div>
      </div>
    );
  }

  dispatchCartMenu = (isMobile, cartMenuStyle) => {
    if (isMobile) {
      return this.renderMobile(cartMenuStyle);
    } else {
      return this.renderDesktop(cartMenuStyle);
    }
  };

  renderDesktop = style => {
    const { showCartMenu, onToggleCartMenu } = this.props;

    return (
      <div
        className={`hidden-mobile open-cart-menu ${
          showCartMenu ? 'menu-open' : ''
        }`}
        css={style}
      >
        <A href="#" onClick={onToggleCartMenu} className="cart">
          <Cart />
          <span className="badge">{this.renderCartItemsQuantity()}</span>
        </A>

        {this.renderCartMenu()}
      </div>
    );
  };

  renderMobile = style => {
    return (
      <div className="hidden-desktop open-cart-menu" css={style}>
        <A href="/carrello" className="cart">
          <Cart />
          <span className="badge">{this.renderCartItemsQuantity()}</span>
        </A>
      </div>
    );
  };

  render() {
    const { primaryColor, uiVariantButton, isMobile } = this.props;
    const cartMenuStyle = css`
      &.menu-open .cart-menu:after {
        border-bottom-color: ${primary_s20_l70_a025(primaryColor)}!important;
      }
      .cart-menu {
        border-color: ${primary_s5_l70_a015(primaryColor)}!important;
        box-shadow: 2px 30px 30px 20px
          ${primary_s20_l70_a025(primaryColor)}!important;
      }
      a.cart {
        color: ${primaryColor}!important;
        &:focus,
        &:hover {
          color: ${primary_l50(primaryColor)}!important;
        }

        .badge {
          border-radius: ${uiVariantButton === '1'
            ? '8px'
            : uiVariantButton === '3'
            ? '4px'
            : 0};
        }
      }
    `;
    return <>{this.dispatchCartMenu(isMobile, cartMenuStyle)}</>;
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    cart: state.cart,
    advancedGa: state.store.data.features.advancedGa,
    globalState: state,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

export default connect(mapStateToProps, { updateCartQuantity, removeFromCart })(
  onClickOutside(CartMenu)
);
